import { NONCE } from '../../shared/constants'
import { devMode } from '../../util/env'
import { buildQueryString } from '../../util/string'

export const ADD_ESTATE_TO_LIST = 'ksk001/shortlist/ADD_ESTATE_TO_LIST'
export const ADD_ESTATE_TO_LIST_SUCCESS =
  'ksk001/shortlist/ADD_ESTATE_TO_LIST_SUCCESS'
export const ADD_ESTATE_TO_LIST_FAILURE =
  'ksk001/shortlist/ADD_ESTATE_TO_LIST_FAILURE'
export const GET_ESTATE_LIST = 'ksk001/shortlist/GET_ESTATE_LIST'
export const GET_ESTATE_LIST_SUCCESS =
  'ksk001/shortlist/GET_ESTATE_LIST_SUCCESS'
export const GET_ESTATE_LIST_FAILURE =
  'ksk001/shortlist/GET_ESTATE_LIST_FAILURE'
export const REMOVE_ESTATE_FROM_LIST =
  'ksk001/shortlist/REMOVE_ESTATE_FROM_LIST'
export const REMOVE_ESTATE_FROM_LIST_SUCCESS =
  'ksk001/shortlist/REMOVE_ESTATE_FROM_LIST_SUCCESS'
export const REMOVE_ESTATE_FROM_LIST_FAILURE =
  'ksk001/shortlist/REMOVE_ESTATE_FROM_LIST_FAILURE'

export const initialState = {
  items: [],
  error: null,
  isLoading: false,
  isLoaded: false,
  isAdding: false,
  isRemoving: false,
}

export default (state = initialState, action) => {
  const { type, payload = {} } = action

  switch (type) {
    case ADD_ESTATE_TO_LIST:
      return {
        ...state,
        isAdding: true,
      }
    case ADD_ESTATE_TO_LIST_SUCCESS:
      return {
        ...state,
        isAdding: false,
        items: [...state.items, payload],
      }
    case ADD_ESTATE_TO_LIST_FAILURE:
      return {
        ...state,
        isAdding: false,
        error: payload.error,
      }
    case GET_ESTATE_LIST:
      return {
        ...state,
        isLoading: true,
      }
    case GET_ESTATE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        items: payload,
      }
    case GET_ESTATE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    case REMOVE_ESTATE_FROM_LIST:
      return {
        ...state,
        isRemoving: true,
      }
    case REMOVE_ESTATE_FROM_LIST_SUCCESS:
      return {
        ...state,
        isRemoving: false,
        items: state.items.filter(item => item !== payload),
      }
    case REMOVE_ESTATE_FROM_LIST_FAILURE:
      return {
        ...state,
        isRemoving: false,
        error: payload.error,
      }
    default:
      return state
  }
}

export const addEstateToList = id => (dispatch, getState) => {
  if (getState().shortlist.items.includes(id)) {
    return false
  }

  dispatch({
    type: ADD_ESTATE_TO_LIST,
  })

  const query = buildQueryString({
    id,
  })

  return fetch(`/wp-json/dhsv/v1/short-list/add?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if ('id' in json) {
          dispatch({
            payload: json.id,
            type: ADD_ESTATE_TO_LIST_SUCCESS,
          })
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error.message,
        },
        type: ADD_ESTATE_TO_LIST_FAILURE,
      })
      throw error
    })
}

export const getEstateList = () => dispatch => {
  dispatch({
    type: GET_ESTATE_LIST,
  })

  return fetch(`/wp-json/dhsv/v1/short-list/get`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        dispatch({
          payload: json,
          type: GET_ESTATE_LIST_SUCCESS,
        })

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
        },
        type: GET_ESTATE_LIST_FAILURE,
      })
      throw error
    })
}

export const removeEstateFromList = id => dispatch => {
  dispatch({
    type: REMOVE_ESTATE_FROM_LIST,
  })

  const query = buildQueryString({
    id,
  })

  return fetch(`/wp-json/dhsv/v1/short-list/remove?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if ('id' in json) {
          dispatch({
            payload: json.id,
            type: REMOVE_ESTATE_FROM_LIST_SUCCESS,
          })
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
        },
        type: REMOVE_ESTATE_FROM_LIST_FAILURE,
      })
      throw error
    })
}
